module.exports = __webpack_public_path__ + "static/media/ice-skate.cb1f956a.svg";